import { render, staticRenderFns } from "./ChangeStore.vue?vue&type=template&id=5c2688f4&"
import script from "./ChangeStore.vue?vue&type=script&lang=js&"
export * from "./ChangeStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports